import React, { useEffect, useState } from 'react'; // useState kept for oems list
import { getListOem } from '@/services/api/oems';
import dayjs from 'dayjs';

interface OemOption {
  id: string;
  name: string;
}

interface Props {
  selectedOemId: string;
  selectedPeriod: string;
  onOemChange: (id: string) => void;
  onPeriodChange: (period: string) => void;
  onExport: () => void;
  isLoading: boolean;
  hasData: boolean;
  isExporting: boolean;
}

const InvoiceControlsBar: React.FC<Props> = ({
  selectedOemId,
  selectedPeriod,
  onOemChange,
  onPeriodChange,
  onExport,
  isLoading,
  hasData,
  isExporting,
}) => {
  const [oems, setOems] = useState<OemOption[]>([]);

  useEffect(() => {
    getListOem({ page: '1', size: '100' })
      .then((res) => {
        setOems(
          (res.data ?? []).map((o: any) => ({ id: o.ID, name: o.name }))
        );
      })
      .catch(() => {});
  }, []);

  // Only show completed or in-progress months; never project a future billing month.
  const maxPeriod = dayjs().format('YYYY-MM');

  const periodOptions: string[] = [];
  const start = dayjs().subtract(23, 'month');
  for (let i = 0; i <= 24; i++) {
    const p = start.add(i, 'month').format('YYYY-MM');
    if (p <= maxPeriod) periodOptions.push(p);
  }
  periodOptions.sort((a, b) => (a < b ? 1 : -1));

  const currentMonth = dayjs().format('YYYY-MM');
  const isInProgress = selectedPeriod === currentMonth;

  return (
    <div className="flex flex-wrap items-end gap-4 mb-6">
      <div className="flex flex-col gap-1">
        <label className="text-xs font-medium text-gray-600 uppercase tracking-wide">
          OEM
        </label>
        <select
          value={selectedOemId}
          onChange={(e) => onOemChange(e.target.value)}
          className="border border-gray-300 rounded-lg px-3 py-2 text-sm min-w-[180px] focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          <option value="">Select OEM…</option>
          {oems.map((o) => (
            <option key={o.id} value={o.id}>
              {o.name}
            </option>
          ))}
        </select>
      </div>

      <div className="flex flex-col gap-1">
        <label className="text-xs font-medium text-gray-600 uppercase tracking-wide">
          Billing Period
        </label>
        <select
          value={selectedPeriod}
          onChange={(e) => onPeriodChange(e.target.value)}
          className="border border-gray-300 rounded-lg px-3 py-2 text-sm min-w-[160px] focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          <option value="">Select period…</option>
          {periodOptions.map((p) => (
            <option key={p} value={p}>
              {p}
            </option>
          ))}
        </select>
        {isInProgress && selectedPeriod && (
          <p className="text-xs text-amber-600">
            Period in progress — active days calculated as of today.
          </p>
        )}
      </div>

      {/* <div className="relative ml-auto">
        <button
          type="button"
          disabled={!hasData || isLoading || isExporting}
          onClick={() => onExport()}
          className="flex items-center gap-2 border border-gray-300 bg-white rounded-lg px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed"
        >
          <i className="ri-download-line text-[14px]" />
          {isExporting ? 'Exporting…' : 'Export CSV'}
        </button>
      </div> */}
    </div>
  );
};

export default InvoiceControlsBar;
